@if (data) {
  <qrcode [qrdata]="data"
          [width]="qrWidth"
          errorCorrectionLevel="M"
          elementType="svg">
  </qrcode>
}
